<template>
  <section class="page-offset overflow-hidden pb-8 lg:pb-20">
    <div class="container">
      <h2 class="heading">
        {{ $t('Employees') }}
      </h2>
      <p>
        {{ $t('Employees description') }}
      </p>
      <div class="pt-4 lg:pt-14">
        <EmployeesList :employees="employees" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import {useEmployeesQuery} from '~/graphql/graphql';

const {result: queryResult} = useEmployeesQuery();
const employees = computed(() => queryResult.value?.employees ?? []);
</script>
